<app-status-pipeline
  [pageView]="pageView()"
  [steps]="steps"
  [currentStatus]="currentStatus"
  [propertyType]="propertyType()"
></app-status-pipeline>
